import FastMarquee from "react-fast-marquee";
import { Diamond } from "@phosphor-icons/react";

const ITEMS = ["Patents", "Trademarks", "Designs", "Copyrights", "Patent Analytics", "Job-Work Support"];

export default function Marquee() {
  return (
    <section data-testid="editorial-marquee" className="py-10 border-y border-gold/20 overflow-hidden bg-navy-950">
      <FastMarquee speed={25} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center shrink-0">
            <span className="font-serif uppercase text-5xl sm:text-7xl text-outline-gold px-8 tracking-wide whitespace-nowrap">
              {item}
            </span>
            <Diamond size={22} weight="fill" className="text-gold shrink-0" />
          </span>
        ))}
      </FastMarquee>
    </section>
  );
}
